/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

var currency = {
  formatMoney: function(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = 2;
      thousands = ',';
      decimal = '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = number.toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
};

// Insert any custom theme js here...
$(document).ready(function() {
  const $dataCartItems = $('[data-cart-item-input-quantity]');
  if($dataCartItems.length > 0) {
    $('[data-cart-item-input-quantity]').each(function(index) {
      let quantity = parseInt($(this).val(), 10);
      if (isNaN(quantity) || quantity <= 1) {
          $(this).val(1).trigger('input');
      }
      if(index === $dataCartItems.length - 1) {
        setTimeout(() => {
          $('[data-cart-submit]').attr('disabled', false);                  
        }, 1600)
      }
    });
  } else {
    $('[data-cart-submit]').attr('disabled', false);    
  }
  
  // Article progress indicator
  if($('#content-hub-progress').length) {
    var progress = $('#content-hub-progress');
    var siteHeader = $('.site-header');
    var preHeader = $('.content-hub__preheader');
    
   	$(window).on('scroll', function(){
      var s = $(window).scrollTop(),
          d = $(document).height(),
          c = $(window).height();

      var scrollPercent = (s / (d - c)) * 100;

      progress.val(scrollPercent);
      progress.html(scrollPercent + '%');

      if(siteHeader.hasClass('site-header--fixed') && s > 166) {
        preHeader.addClass('site-header--fixed');
      } else {
        preHeader.removeClass('site-header--fixed');
      }
  	}) 
  }  
  
  if($('.content-hub-archive__tags').length) {
    $('.content-hub-archive__tags').on('change', function() {
      var url = $(this).find('option:checked').data('href');
      document.location.href = url;
    });
  }
  
  // Subscription page magic buttons
  if($('.single-option-button-selector').length) {
    $('.single-option-button-selector').on('click', function(e) {
      e.preventDefault();
      
      var id = $(this).data('target');
      var value = $(this).data('value');
      var form = $(this).closest('form');
      var control = $('#' + id + '.single-option-selector');
      
      $(this).siblings().removeClass('selected');
      $(this).addClass('selected');
      
      $(control).find('option').removeAttr('selected');
      $(control).find('option[value="' + value + '"]').attr('selected', 'selected');
      $(control).val(value).trigger('change');
    });
  }
  
  if($('.subscription-delivery-amount').length) {
    var target_del_amt = '.subscription-delivery-amount';
    var watch_frq_num = '.bold-ro__frequency-num';   
    
    $('.ro_widget').on('change', watch_frq_num, function(e) {
      	$(target_del_amt).html($(watch_frq_num).val());
    });    
  }
  
  if($('.subscription-delivery-unit').length) {
    var target_del_unt = '.subscription-delivery-unit';
    var watch_frq_type = '.bold-ro__frequency-type';   
    
    $('.ro_widget').on('change', watch_frq_type, function(e) {
      var val = $(watch_frq_type).children('option:selected').html();
      $(target_del_unt).html(val);
    });  
  }

  $('body').on('click', '.subscription-step', function() {
    console.log('clicked something dill');
  })
  
  if($('.accordion-container-n').length) {
  	var accordion = new Accordion('.accordion-container-n', {
      duration: 400,
      showItem: true,
      onToggle: function(currentElement) {
        // Select the node that will be observed for mutations
        var parentNode = currentElement.querySelector('.ac-a');
        var targetNode = currentElement.querySelector('.trustshop-review--list');
        var sizeNode = currentElement.querySelector('.trustshop-layout-box--left');
        
        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true };
        
        // Callback function to execute when mutations are observed
        var callback = function(mutationsList) {
          const size = sizeNode.getBoundingClientRect();
          parentNode.style.height = size.height + 80 + 'px'; 
        };
        
        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);
        
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
      }
    });
  }
  
  if($('.sticky-panel').length) {
   	// Sticky sections
    var sticky = new Sticky('.sticky-panel');

    // Accordion
    var accordion = new Accordion('.accordion-container', {
      duration: 400,
      onToggle: function(currentElement, allElements) {
        var stickyPanel = $('.sticky-panel');
        var stickyContainer = $('.sticky-container');
        
        setTimeout(function() {
          var containerBottom = stickyContainer.offset().top + stickyContainer.outerHeight();
          var panelBottom = stickyPanel.offset().top + stickyPanel.outerHeight();
          
          const difference = containerBottom - panelBottom;
          if(difference < 0) {
            stickyPanel.animate({
              top: difference
          	}, 200);
          }
        }, 400);
      },
      showItem: true
    });
    
    $('#open-shipping').on('click', function(e) {	
      $('.ac h2:contains("Shipping Information")').trigger('click');      	
    });
    
    // Set size of sticky container to be minimum height of sticky el
    sizeStickyContainer('.sticky-panel');
    
    window.addEventListener('resize', function() {
      sizeStickyContainer('.sticky-panel'); 
    });

    function sizeStickyContainer(el) {
      var height = $(el).outerHeight();
      $(el).closest('.sticky-container').css({
        minHeight: height
      });
    }
  } 
  
  $('#shopify-product-reviews').on('click', '.spr-summary-actions-newreview', function() {
    var section = $('#shopify-product-reviews'); 
    var height = section.outerHeight() + 10;
    section.parent().height(height);
  });
  
  
  // Disable grind if other selections don't match possible variants
  if($('.product-form-alt').length) {
  	var $productJSON = $('[data-product-json]');
    var product = JSON.parse($productJSON.html());
    var useFields = product.options;
    if(useFields.indexOf('Grind') !== -1) {
      useFields.splice(useFields.indexOf('Grind'), 1); 
    }
    var grindOptions = [];
    $('#Grind option').each(function(i, option) {
      grindOptions.push(option.value);
    });    
    
    $('.product-form-alt').on('change', function(e) {
      var values = [];      
      $.each($(this).serializeArray(), function(i, field) {
        if(useFields.indexOf(field.name) == -1) {
           return;
        }
        
        values.push(field.value);
      });      
      
      $.each(grindOptions, function(i, option) {
        var hasGrindOption = false;
        $.each(product.variants, function(i, variant) {
          var hasAllValues = true;
          $.each(values, function(i, value) {
            if(variant.options.indexOf(value) == -1) {
              hasAllValues = false;
            }
          });
          
          if(hasAllValues) {
            if(variant.options.indexOf(option) != -1) {
              hasGrindOption = true;
            }
          }
        });
        
        if(hasGrindOption) {
          $('.grind-selection-wrap [data-value="' + option + '"]').removeClass('disabled');
        } else {
          $('.grind-selection-wrap [data-value="' + option + '"]').addClass('disabled');
        }
      });
    });   
  } 
  
  
  if($('#product-review-summary').length) {
    var target = $('#product-review-summary .summary');
    var parent = $('#shopify-product-reviews');
    var stars = parent.find('.spr-summary-starrating').html();
    var numReviews = parent.find('.spr-summary-actions-togglereviews').html();
    if(numReviews) {
    	numReviews = numReviews.replace(/[^0-9]/g, '');   
    
    	target.html(stars + '<span>(' + numReviews + ')</span>');  
    } else {
      target.parent().css({opacity: 0});
    }
  }
  
  if($('.product-form-alt').length) {
    var el = document.getElementById('Quantity-alternate-product-template');
    var spinner = new ISpin(el, {
      wrapperClass: 'ispin-wrapper',
      buttonsClass: 'ispin-button',
      parse: function(val) {
        if(val < 1) {
          return Number(1);  
        }
        return Number(val);
      }
    });
  }
  
  $('.product-form-alt select:not(.not-nice):not(.bold-ro__frequency-num):not(.bold-ro__frequency-type)').niceSelect();
  
  if($('.subscription-selection').length) {    
    $('.ro_widget').on('click', '.bold-ro__recurring-lbl', function() {
      if($(this).find('input').hasClass('bold-ro__subscribe-radio-btn')) {
       	$('.price-display').addClass('subscribe');
      } else {
        $('.price-display').removeClass('subscribe');
      }
    });
  }
  
  function updateSubscriptionPrice() {
    setTimeout(function() {
      //BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed');   
      if($('.bold-ro__initial-discount-price').length) {        
       	setTimeout(function() {
          var price = $('.bold-ro__initial-discount-price').text();
          price = parseFloat(price.replace('$', ''));
          var quantity = $('.product-form__item input[name="quantity"]').val();
          price = price * quantity;
          price = currency.formatMoney(price, theme.moneyFormat)
          $('.product__sub-price').text(price);
        }, 100);       
      }
    }, 100);
  }
  
  $('.product-form__item').on('change', 'select, input[name="quantity"]', updateSubscriptionPrice);
  $('.product-form__item').on('click', '.ispin-button', updateSubscriptionPrice);
  
  function updatePrepaidGiftPrice() {	
    setTimeout(function() {	
      var price = parseFloat($('.bold-ro__prepaid-total').text().replace('$', ''));	
      if($('.product-form__item input[name="quantity"]').length) {	
        var quantity = $('.product-form__item input[name="quantity"]').val();	
        price = price * quantity;  	
      }      	
      price = currency.formatMoney(price, theme.moneyFormat);	
      $('*[data-regular-price]').text(price);	
    }, 100);       	
  }
  
  setTimeout(function() {
    if($('.bold-ro__initial-discount-price').length) {
      var price = $('.bold-ro__initial-discount-price').text();
      var normal_price = $('.product__sub-price').text(price);    
      if(price == normal_price) {
        $('.product__crossed-price').remove();
      } else {
        updateSubscriptionPrice();
      }
    }
    
    if($('.bold-ro__prepaid-total').length) {	
      updatePrepaidGiftPrice(); 	
      $('.ro_widget').on('DOMSubtreeModified', '.bold-ro__prepaid-total', updatePrepaidGiftPrice);
    }
  }, 1000);
  
  $('.alt-product-template').on('variant_change', function() {
    $('.product-form-alt select:not(.not-nice):not(.bold-ro__frequency-num):not(.bold-ro__frequency-type)').niceSelect('update');
  });
  
  if($('.siema').length) {
   	var mySiema = new Siema({
      perPage: {
        800: 2,
        1200: 3,
        1400: 4
      },
      onInit: function() {
        window.dispatchEvent(new Event('resize'));
      },
      onChange: function(e) {
        if($(window).width() <= 782) {
          var anchors = $('a.product-slideshow__control');
          var id = $(anchors[this.currentSlide]).data('id');
          var activeSlide = $('.product__image-container[data-id="' + id + '"]');
          $('.product__image-container').addClass('hide');
          activeSlide.removeClass('hide');
        }
      }
    });  
    document.querySelector('.siema_prev').addEventListener('click', () => mySiema.prev());
    document.querySelector('.siema_next').addEventListener('click', () => mySiema.next()); 
  }
  
  $('.occurence-btn').on('click', function(e) {
    e.preventDefault();
    var frequencyEl = $('.bold-ro__frequency-num');
    var typeEl = $('.bold-ro__order-interval');
    
    var frequency = $(this).data('frequency');
    var type = $(this).data('freq-type');
    
    $('.occurence-btn.selected').removeClass('selected');
    $(this).addClass('selected');
    
    frequencyEl.val(frequency);
    frequencyEl.trigger('change');
    
    typeEl.val(type);    
    typeEl.trigger('change');
    
    var typeText = 'Week(s)';
    
    if(type == 3) {
      typeText = 'Month(s)';
    } 
    
    $('.bold-ro__frequency-type-text').val(typeText);
  });
  
  if($('.subscription-page__size').length) {
    var $productJSON = $('[data-product-json]');
    var product = JSON.parse($productJSON.html());
    var sizeLocation = product.options.indexOf('Size');
    
    if(sizeLocation == -1) {
      return; 
    }
    
    var $parent = $('.subscription-page__size');
    
    $parent.find('.size-selector').each(function() {
      var dataVal = $(this).data('value');
      var priceSelector = $(this).find('.price');
      var struckPriceSelector = $(this).find('.struck-price');
      
      $.each(product.variants, function(index, el) {
        if(el.option3 == dataVal) {
          var price = '$' + el.price / 100;
          var struckPrice = null;
          
          const sellingOptions = el.selling_plan_allocations[0];
          if(sellingOptions.price !== sellingOptions.compare_at_price && sellingOptions.price > 0) {
            struckPrice = '$' + sellingOptions.compare_at_price / 100;
            price = '$' + sellingOptions.price / 100;
          }
          priceSelector.html(price);
          if(struckPrice) {
            struckPriceSelector.html(struckPrice);
          }
          return false;
        }
      });
    })
  }
  
  // Auto Scrollers
  function scrollToSection(id) {
    setTimeout(function() {
      $('body,html').animate({
        scrollTop: $(id).offset().top
      }, 400);
    }, 300);
  }
  
  if($('.subscription-page__intro').length) {
    $('.start-subscription-btn').on('click', function(e) {
      e.preventDefault();
      scrollToSection("#blend-section");
    });
    
    $('.blend-selector').on('click', function(e) {
      scrollToSection("#grind-section");
    });
    
    $('.grind-selector').on('click', function(e) {
      if($('#sample-section').length) {
        scrollToSection("#sample-section");        
      } else {
        scrollToSection("#size-section");  
      }
    });
    
    $('.size-selector').on('click', function(e) {
      scrollToSection("#occurence-section");
    });
    
    $('.occurence-btn').on('click', function(e) {
      scrollToSection("#finalise-section");
    });
  }

  $('.subscription-page__size .size-selector').each(function() {
    const priceEl = $(this).find('.price')
    let price = priceEl[0].innerHTML.replace('$', '');
    if(price) {
      price = parseFloat(price);
    }
    
    const sizeEl = $(this).find('.selection-size');
    let cupSize = sizeEl[0].innerHTML;
    const regex = /\d+/; // Match one or more digits
    const matches = cupSize.match(regex);
    let cups = matches[0];

    if(cups) {
      cups = parseInt(cups);
    }

    if(!cups || !price) {
      return;
    }

    const pricePerCup = price / cups;
    const el = $(this).find('.price-per-cup');
    const pricePerCupString = '$' + pricePerCup.toFixed(2) + '/cup';
    el[0].innerHTML = pricePerCupString;
  })
  
  let singleSamples = [];
  $('.sample__select--single').each(function(e) {
    const $this = $(this);
    const thisId = $this.data('id');
    singleSamples.push(thisId);
  })

  // Per-sample quantity map: { sampleId: qty }. Replaces the previous selectedSamples array
  // so customers can pick e.g. 2 of one bag and 1 of another within the same selection budget.
  let sampleQtys = {};
  const sampleSize = $('#sample-section').data('selection-size');
  const SELECTION_SIZE = sampleSize || 3;

  function totalSelectedQty() {
    return Object.values(sampleQtys).reduce((sum, q) => sum + q, 0);
  }

  function refreshSampleUI(isSingleSelection) {
    $('.sample__select').each((index, el) => {
      $(el).removeAttr('data-index');
    });
    Object.keys(sampleQtys).forEach((id, idx) => {
      $(`*[data-id="${id}"]`).attr('data-index', idx + 1);
      const $el = $(`.sample__select[data-id="${id}"]`);
      $el.find('[data-qty-input]').val(sampleQtys[id]);
    });
    const total = totalSelectedQty();
    const displayAmount = isSingleSelection ? SELECTION_SIZE : total;
    $('.subscription-page__sample-selected-text .selected-text-num').html(displayAmount);
    $('.subscription-page__sample-num-bar span').css('width', (100 / SELECTION_SIZE) * displayAmount + '%');
    if(displayAmount >= SELECTION_SIZE) {
      scrollToSection("#size-section");
    }
  }

  // Qty +/- buttons inside selected samples (manual coffees only — Trust Us single uses bundle).
  $(document).on('click', '.sample__qty-btn', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const $btn = $(this);
    const $card = $btn.closest('.sample__select');
    const id = $card.data('id');
    if(!sampleQtys[id]) return; // only operates when card is selected
    const action = $btn.attr('data-qty-action');
    const current = sampleQtys[id];
    if(action === 'plus') {
      if(totalSelectedQty() < SELECTION_SIZE) {
        sampleQtys[id] = current + 1;
      }
    } else if(action === 'minus') {
      if(current <= 1) {
        delete sampleQtys[id];
        $card.removeClass('selected');
      } else {
        sampleQtys[id] = current - 1;
      }
    }
    refreshSampleUI();
  });

  // Manual qty input — accept typed numbers, clamp to remaining capacity.
  $(document).on('click', '.sample__qty-input', function(e) {
    e.stopPropagation();
  });
  $(document).on('change', '.sample__qty-input', function(e) {
    e.stopPropagation();
    const $input = $(this);
    const $card = $input.closest('.sample__select');
    const id = $card.data('id');
    if(!sampleQtys[id]) return;
    let val = parseInt($input.val(), 10);
    if(isNaN(val) || val < 1) val = 1;
    const otherTotal = totalSelectedQty() - sampleQtys[id];
    const maxAllowed = Math.max(1, SELECTION_SIZE - otherTotal);
    if(val > maxAllowed) val = maxAllowed;
    sampleQtys[id] = val;
    refreshSampleUI();
  });
  // Block Enter from submitting the surrounding subscription form when adjusting qty
  $(document).on('keydown', '.sample__qty-input', function(e) {
    if(e.key === 'Enter') {
      e.preventDefault();
      $(this).blur();
    }
  });

  // Product sample selection (whole-card click — toggles selection)
  $('.sample__select').on('click', function(e) {
    // Clicks on the qty controls inside a selected card are handled separately —
    // don't let them toggle selection.
    if($(e.target).closest('.sample__qty').length) return;
    e.preventDefault();
    let isSingleSelection = false;
    const $this = $(this);
    const thisId = $this.data('id');
    if($this.hasClass('selected')) {
      $this.removeClass('selected');
      delete sampleQtys[thisId];
    } else {
      if($this.hasClass('sample__select--single')) {
        $('.sample__select').removeClass('selected');
        sampleQtys = { [thisId]: 1 };
        isSingleSelection = true;
        $this.addClass('selected');
      } else {
        // If a single-bundle sample was previously selected, clear it before manual picks
        if(Object.keys(sampleQtys).length && singleSamples.includes(parseInt(Object.keys(sampleQtys)[0], 10))) {
          $('.sample__select').removeClass('selected');
          sampleQtys = {};
        }
        if(totalSelectedQty() < SELECTION_SIZE) {
          sampleQtys[thisId] = 1;
          $this.addClass('selected');
        }
      }
    }
    refreshSampleUI(isSingleSelection);
  })

  // Sticky sample section
  var $sampleNumBar = $('.subscription-page__sample-num-bar-wrapper');
  if($sampleNumBar.length) {
    $sampleNumBar.clone().appendTo('body').addClass('floating');
    $section = $('.subscription-page__sample');

    $(window).on('scroll', function(e) {
      var scrollPos = $(document).scrollTop();
      var elPos = $sampleNumBar.offset();
      var elHeight = $sampleNumBar.height();
      var windowHeight = $(window).height();
      var endSection = $section.offset();
      var endSectionHeight = $section.height();
  
      if(scrollPos + windowHeight > elPos.top && scrollPos < endSection.top + endSectionHeight) {
        $('.subscription-page__sample-num-bar-wrapper.floating').addClass('sticky');  
      } else {
        $('.subscription-page__sample-num-bar-wrapper.floating').removeClass('sticky');
      }
    })
  }

  if($('#finalise-section').length > 0) {
    const $sellingPlanSelector = $('.selling-plan-allocation');

    var $productJSON = $('[data-product-json]');
    var product = JSON.parse($productJSON.html());

    $('.product-template').on('variant_change', function() {  
      const variantSelector = document.querySelector('select[name="id"]');
      const currentProduct = product.variants.find(v => v.id == variantSelector.value);

      if(!currentProduct) {
        return;
      }

      const sellingPlanAllocations = currentProduct.selling_plan_allocations

      if(!sellingPlanAllocations || sellingPlanAllocations.length < 1) {
        return;
      }

      const discountPrice = sellingPlanAllocations[0].price;
      $sellingPlanSelector.find('.product__discount-price').html(`$${(discountPrice / 100).toFixed(2)}`)
      $sellingPlanSelector.removeClass('hidden');
      // $sellingPlanSelector.html(`
      //   <div class="price-box price-box__single">
      //     <p>Introductory<br />Offer</p>
      //     <p class="price"><span class="product__discount-price"></span></p>
      //   </div>
      // `)
    })    
  }
});
